import React, { useCallback } from "react";
import { useAxiosAuth0 } from "@shared/config/useAxiosAuth0";
import LinkBandwidthChart from "kontrolEdge/components/Shared/Bandwidth/LinkBandwidthChart";
import { fetchCarrierAccessPerformance } from "../requests/request";
import type { CarrierAccessLeg } from "../carrierAccess.types";

interface Props {
  carrierAccessId: number;
  leg: Pick<CarrierAccessLeg, "kind" | "id">;
  /** Card title after "Bandwidth Utilization —". Never an interface name. */
  title: string;
  tenantId: number;
}

/**
 * Bandwidth Utilization of one carrier, read from its VLAN, so the active and
 * the standby read side by side (Jose, PR #696). Interface names stay off the
 * page.
 */
const CarrierLegBandwidthChart: React.FC<Props> = ({
  carrierAccessId,
  leg,
  title,
  tenantId,
}) => {
  const api = useAxiosAuth0();
  const { kind, id } = leg;

  const fetchBandwidth = useCallback(
    async (interval: string, timeRange: string) => {
      const response = await fetchCarrierAccessPerformance(
        api,
        tenantId,
        carrierAccessId,
        { kind, id },
        interval,
        timeRange
      );
      const utilization = response.data?.data?.bandwidthUtilization;
      return response.data?.success && utilization
        ? { inbound: utilization.inbound, outbound: utilization.outbound }
        : null;
    },
    [api, tenantId, carrierAccessId, kind, id]
  );

  return <LinkBandwidthChart title={title} fetchBandwidth={fetchBandwidth} />;
};

export default CarrierLegBandwidthChart;
